// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "assets/" + chunkId + "." + "eace7fea579a572ba74f" + ".chunk.min.js";
};